<template>
    <div class="contactCreate scroll-container">
        <div class="casTips resultTips" style="display: none;">
            <img src="https://resource.rcclchina.com.cn/tui2/user_center/member/yTipsIcon.png">
            <span>系统未匹配到您的会员信息，请输入航线信息进行再次验证</span>
        </div>
        <div class="casTips">
            <img src="https://resource.rcclchina.com.cn/tui2/user_center/member/yTipsIcon.png">
            <span>{{casTips}}</span>
        </div>
        <div class="contactCreate-list">
            <div class="passenger-detail-desc">

                <div class="passenger-content">
                    <div class="passenger-family">姓拼音</div>
                    <div class="passenger-txt">
                        <input type="text" placeholder="必填" id="lastName" class="lastNamePY" v-model="lastName">
                    </div>
                </div>

                <div class="passenger-content">
                    <div class="passenger-family">名拼音</div>
                    <div class="passenger-txt">
                        <input type="text" placeholder="必填" id="firstName" class="firstNamePY" v-model="firstName">
                    </div>
                </div>

                <div class="passenger-content passenger-birthDate">
                    <div class="passenger-family">出生日期</div>
                    <div class="passenger-txt">
                        <input type="date" placeholder="必填" value="" id="birthDate" class="birthOfDate input-text-left" v-model="dateOfBirth">
                    </div>
                    
                        <img src="https://resource.rcclchina.com.cn/tui2/user_center/calender-icon.png">
                    
                </div>

                <div class="bindLoyalty-booking" :class="{ active: isShowBooking}">
                    <div class="passenger-content">
                        <div class="passenger-family">预订号</div>
                        <div class="passenger-txt">
                            <input type="text" placeholder="必填" value="" id="bookingId" class="firstNamePY" v-model="bookingId">
                        </div>
                    </div>

                    <div class="passenger-content">
                        <div class="passenger-family">游轮名称</div>
                        <div class="passenger-txt">
                            <select id="shipCode" v-model="shipCode">
                                <option value="">选择游轮</option>
                                <option value="QN">海洋量子号</option>
                                <option value="MA">海洋水手号</option>
                                <option value="VY">海洋航行者号</option>
                                <option value="OV">海洋赞礼号</option>
                                <option value="AL">海洋魅丽号</option>
                                <option value="JW">海洋珠宝号</option>
                                <option value="NV"></option>
                                <option value="OA">海洋绿洲号</option>
                                <option value="VI"></option>
                                <option value="RD">海洋灿烂号</option>
                                <option value="EX">海洋探险者号</option>
                                <option value="HM">海洋和悦号</option>
                                <option value="RH">海洋迎风号</option>
                                <option value="SC">海洋光谱号</option>
                                <option value="SY">海洋交响号</option>
                            </select>
                        </div>
                    </div>

                    <div class="passenger-content passenger-birthDate">
                        <div class="passenger-family">出行日期</div>
                        <div class="passenger-txt">
                            <input ontouchstart="" type="date" placeholder="必填" v-model="sailDate" id="sailDate" class="birthOfDate input-text-left">
                        </div>
                        <img src="https://resource.rcclchina.com.cn/tui2/user_center/calender-icon.png">
                    </div>
                </div>

            </div>
        </div>

        <div class="contactCreate-addGuestBtn" id="bindLoyaltySubmitBtn" @click="submit">找回会员号</div>

    </div>
</template>

<script>
import api from '@/api'
export default {
    name: "BindLoyalty",
    data () {
        return {
            isShowBooking: false,
            lastName: '',
            firstName: '',
            dateOfBirth: '1980-01-01',
            bookingId: '',
            sailDate: '',
            shipCode: '',
            casTips: '已出行会员通过此处找回会员号'
        }
    },
    beforeMount () {
        this.$store.commit('SET_PAGE_TITLE', '找回会员号')
    },
    mounted () {
        const userToken = this.$store.state.user.userToken
        if (!userToken || userToken.length == 0) {
            return this.$router.push({ name: 'Login', query:{ 
                returnUrl: location.href
            }})
        } 
    },
    methods: {
        async submit() {
            if (!this.checkForm()) return
            
            let requestData = {
                lastName: this.lastName,
                firstName: this.firstName,
                dateOfBirth: this.dateOfBirth
            }
            if (this.isShowBooking) {
                requestData.bookingId = this.bookingId
                requestData.shipCode = this.shipCode
                requestData.sailDate = this.sailDate
            }
            this.$loading.show()
            const { success, data } = await api.user.bindLoyalty(requestData)
            this.$loading.hide()
            if (success) {
                return this.goBack()
            } else if (data == 1001) {
                this.isShowBooking = true
                this.casTips = '系统未匹配到您的会员信息，请输入航线信息进行再次验证'
            } else {
                let url = '/Rccl.UserCenter/CustomerInfo/CreateCas'
                if (this.$router.currentRoute.query.returnUrl) {
                    url += '?returnUrl=' + encodeURIComponent(this.$router.currentRoute.query.returnUrl)
                }
                this.$router.push(url)
            }
        },
        checkForm() {
            if (!this.lastName || this.lastName.length == 0) {
                this.$alert.show('请输入姓拼音')
                return false
            } else if (!this.firstName || this.firstName.length == 0) {
                this.$alert.show('请输入名拼音')
                return false
            } else if (!this.dateOfBirth || this.dateOfBirth.length == 0) {
                this.$alert.show('请输入出生日期')
                return false
            }

            if (this.isShowBooking) {
                if (!this.bookingId || this.bookingId.length == 0) {
                    this.$alert.show('请输入预订号')
                    return false
                } else if (!this.shipCode || this.shipCode.length == 0) {
                    this.$alert.show('请选择游轮')
                    return false
                } else if (!this.sailDate || this.sailDate.length == 0) {
                    this.$alert.show('请输入出行日期')
                    return false
                }
            }
            return true
        },
        goBack() {
            const query = this.$router.currentRoute.query
            if (query.returnUrl && query.returnUrl.length > 0) {
                location.href = query.returnUrl
            } else {
                this.$router.push('/Rccl.UserCenter/Cas')
            }
        }
    }
}
</script>

<style lang="less" scoped>
.casTips {
    padding: 10px;
    letter-spacing: 1px;
    color: #FF5055;
    font-size: 12px;
    text-align: center;
    img {
        width: 12px;
        position: relative;
        top: 1px;
        margin-right: 3px;
    }
}
.contactCreate-list {
    background-color: #fff;
    padding: 0 12px;
    .passenger-detail-desc {
        background: #fff;
        padding: 0 10px;
        position: relative;
        .passenger-content {
            width: 100%;
            border-bottom: 1px solid rgba(216,216,216,0.6);
            padding: 10px 0;
            position: relative;
            font-size: 14px;
            .passenger-family, .passenger-txt {
                display: inline-block;
                font-size: 14px;
                height: 35px;
                line-height: 37px;
            }
            .passenger-family {
                font-family: PingFang-SC-Medium;
                font-size: 14px;
                color: #333333;
                letter-spacing: 0;
                max-width: 141px;
                overflow: hidden;
                vertical-align: top;
            }
            .passenger-txt {
                margin-left: 10px;
                input {
                    color: #000;
                    outline: none;
                    border: none;
                    height: 35px;
                    width: 250px;
                    background-color: transparent;
                    -webkit-appearance: none;
                    position: relative;
                    z-index: 1;
                    text-align: left;
                    padding-left: 20px;
                }
            }
            
            select {
                display: inline-block;
                border: none;
                font-size: 13px;
                text-indent: 10px;
                appearance: menulist-button;
                -webkit-appearance: menulist-button;
                -moz-appearance: menulist-button;
                font-weight: bold;
                position: relative;
                top: -6px;
                width: 128px;
                vertical-align: -webkit-baseline-middle;
                background-color: transparent;
            }
        }
        .passenger-birthDate, .passenger-pssport {
            position: relative;
            img {
                width: 20px;
                position: absolute;
                top: 16px;
                right: 5px;
                z-index: 0;
            }
        }
    }
}

.passenger-content .passenger-txt input.lastName, .passenger-content .passenger-txt input.firstName, .passenger-content .passenger-txt input.lastNamePY, .passenger-content .passenger-txt input.firstNamePY {
    width: 200px;
    height: 35px;
    overflow: hidden;
}

.bindLoyalty-booking {
    display: none;
}

.bindLoyalty-booking.active {
    display: block;
}


.contactCreate-addGuestBtn {
    background-image: linear-gradient(270deg, #FAD961 0%, #FEBC10 100%);
    font-family: PingFang-SC-Medium;
    font-size: 16px;
    color: #454545;
    letter-spacing: 2.5px;
    padding: 11px 0;
    margin: 10px 0px 0 0px;
    text-align: center;
    position: relative;
}
</style>